import { FC, useCallback, useRef } from 'react';
import { CSSTransition } from 'react-transition-group';
import { useMenuContext } from '#baseMenu/hooks';
import menuBackdrop from '../assets/menu-backdrop.module.scss';

const Backdrop: FC = () => {
  const {
    isVisibleBackdrop,
    showContent,
    setIdToHistoryState,
    refHideSubject,
  } = useMenuContext();
  const refBackdrop = useRef<HTMLDivElement>(null);

  const handlerBackdropEnter = useCallback(() => {
    refBackdrop.current.classList.add(menuBackdrop.menuBackdrop_show);
    setIdToHistoryState();
  }, [setIdToHistoryState]);

  const handlerBackdropEntered = useCallback(() => {
    showContent();
  }, [showContent]);

  const handlerBackdropExit = useCallback(() => {
    refBackdrop.current.classList.remove(menuBackdrop.menuBackdrop_show);
  }, [refBackdrop]);

  const handlerBackdropExited = useCallback(() => {
    refHideSubject.current.next();
  }, [refHideSubject]);

  return (
    <CSSTransition
      nodeRef={refBackdrop}
      in={isVisibleBackdrop}
      timeout={200}
      unmountOnExit
      onEnter={handlerBackdropEnter}
      onEntered={handlerBackdropEntered}
      onExit={handlerBackdropExit}
      onExited={handlerBackdropExited}
    >
      <div ref={refBackdrop} className={menuBackdrop.menuBackdrop} />
    </CSSTransition>
  );
};

export { Backdrop };
